var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      staticClass: "primary",
      attrs: { column: "", role: "region", "aria-label": "FAQ content" },
    },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/faq-cover.png",
          height: "400",
          role: "img",
          "aria-label": "Frequently Asked Questions banner",
        },
      }),
      _vm._v(" "),
      _c(
        "v-container",
        {
          attrs: {
            role: "main",
            "aria-label": "Frequently Asked Questions section",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "1",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.faq.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("components.faq.description"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            _vm._l(_vm.faqList, function (faq) {
              return _c(
                "v-flex",
                {
                  key: faq.id,
                  attrs: { "full-width": "", lg12: "", role: "listitem" },
                },
                [
                  faq.isActive
                    ? _c(
                        "v-card",
                        { attrs: { color: "secondary", "full-width": "" } },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "grey--text text-subtitle-2 primary",
                              attrs: {
                                role: "button",
                                tabindex: 0,
                                "aria-expanded": _vm.isCardVisible(faq.id),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.ViewFAQ(faq.id)
                                },
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.ViewFAQ(faq.id)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.ViewFAQ(faq.id)
                                  },
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(faq.title) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-slide-y-transition",
                            [
                              _c(
                                "v-card-text",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isCardVisible(faq.id),
                                      expression: "isCardVisible(faq.id)",
                                    },
                                  ],
                                  staticClass: "faq-collapsable-text",
                                  attrs: {
                                    role: "region",
                                    "aria-hidden": !_vm.isCardVisible(faq.id),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(faq.description) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }